var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindowsClose = function SvgWindowsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1752.9 -3098.9 9.8 9.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "windows_close_svg__a",
    d: "m-1747.5-3094 4.4 4.4-.5.5-4.4-4.4-4.4 4.4-.5-.5 4.4-4.4-4.4-4.4.5-.5 4.4 4.4 4.4-4.4.5.5Z"
  })));
};
export default SvgWindowsClose;